import { GET_PURCHASE_ORDERS, ADD_PURCHASE_ORDER, UPDATE_PURCHASE_ORDER_STATUS, UPDATE_PURCHASE_ORDER_PRODUCTS, UPDATE_PURCHASE_ORDER_RECEIVED, UPDATE_PURCHASE_ORDER_PAYMENT, UPDATE_PURCHASE_ORDER_PAY_DATE, SHALLOW_DELETE_PURCHASE_ORDER } from 'redux/actionTypes';

function findPurchaseOrderIndex(state, purchaseOrderId) {
    return state.findIndex(purchaseOrder => purchaseOrder.id === purchaseOrderId);
};

export default function purchaseOrders(state = [], action) {
    switch(action.type) {
        case GET_PURCHASE_ORDERS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_PURCHASE_ORDER:
            return [
                action.payload,
                ...state
            ];
        case UPDATE_PURCHASE_ORDER_STATUS:
            const statusIndex = findPurchaseOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, statusIndex),
                {
                    ...state[statusIndex],
                    status: action.payload.status
                },
                ...state.slice(statusIndex + 1)
            ];
        case UPDATE_PURCHASE_ORDER_PRODUCTS:
            const productsIndex = findPurchaseOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, productsIndex),
                {
                    ...state[productsIndex],
                    products: state[productsIndex].products.map(product => {
                        const update = action.payload.updatedProducts.find(updatedProduct => updatedProduct.id === product.id);
                        return update ? {
                            ...product,
                            receivedQuantity: update.receivedQuantity
                        } : product;
                    })
                },
                ...state.slice(productsIndex + 1)
            ];
        case UPDATE_PURCHASE_ORDER_RECEIVED:
            const receivedIndex = findPurchaseOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, receivedIndex),
                {
                    ...state[receivedIndex],
                    received: action.payload.received
                },
                ...state.slice(receivedIndex + 1)
            ];
        case UPDATE_PURCHASE_ORDER_PAYMENT:
            const paymentIndex = findPurchaseOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, paymentIndex),
                {
                    ...state[paymentIndex],
                    payments: action.payload.payments
                },
                ...state.slice(paymentIndex + 1)
            ];
        case UPDATE_PURCHASE_ORDER_PAY_DATE:
            const payDateIndex = findPurchaseOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, payDateIndex),
                {
                    ...state[payDateIndex],
                    paymentDate: action.payload.paymentDate
                },
                ...state.slice(payDateIndex + 1)
            ];
        case SHALLOW_DELETE_PURCHASE_ORDER:
            const deleteIndex = findPurchaseOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, deleteIndex),
                ...state.slice(deleteIndex + 1)
            ];
        default:
            return state;
    }
};